import { Trans } from "@web-monorepo/i18n/macro";
import ShadowCard from "src/shared/components/ShadowCard";
import FullScreenCardPage from "./FullScreenCardPage";
import SlideNavigation from "./SlideNavigation";
import Tag from "./Tag";
import type { RemoteSlideProps, Slide } from "./types";
import styles from "./ExpectationsSlide.module.css";

export const ExpectationsSlide = (): Slide => {
  return {
    remote: ({ next }: RemoteSlideProps) => (
      <div className={styles.remoteFrame}>
        <ShadowCard className={styles.remoteCard}>
          <Trans>
            <div className={styles.remotePreTitle}>It's time for a</div>
            <div className={styles.remoteTitle}>Conundrum!</div>
          </Trans>
          <div className={styles.remoteRememberHeading}>
            <Trans>Remember...</Trans>
          </div>
          <div className={styles.remoteTagWrapper}>
            <Tag size="medium" variant="accent">
              <Trans>Be open-minded</Trans>
            </Tag>
            <Tag size="medium" variant="accent">
              <Trans>Listen to each other</Trans>
            </Tag>
            <Tag size="medium" variant="accent">
              <Trans>There’s no "right" answer!</Trans>
            </Tag>
            <Tag size="medium" variant="accent">
              <Trans>Respect others' opinions</Trans>
            </Tag>
          </div>
        </ShadowCard>
        <SlideNavigation onBack={() => next(-1)} onNext={() => next()} />
      </div>
    ),
    display: () => (
      <FullScreenCardPage className={styles.displayFrame}>
        <Trans>
          <div className={styles.displayPreTitle}>It's time for a</div>
          <div className={styles.displayTitle}>Conundrum!</div>
        </Trans>
        <div className={styles.displayRememberHeading}>
          <Trans>Remember...</Trans>
        </div>
        <div className={styles.displayTagWrapper}>
          <Tag size="large" variant="accent">
            <Trans>Be open-minded</Trans>
          </Tag>
          <Tag size="large" variant="accent">
            <Trans>Listen to each other</Trans>
          </Tag>
          <Tag size="large" variant="accent">
            <Trans>There’s no "right" answer!</Trans>
          </Tag>
          <Tag size="large" variant="accent">
            <Trans>Respect others' opinions</Trans>
          </Tag>
        </div>
      </FullScreenCardPage>
    ),
  };
};
